import { render } from "./AssignRangeCardBox.vue?vue&type=template&id=0aa35a2a&scoped=true"
import script from "./AssignRangeCardBox.vue?vue&type=script&lang=js"
export * from "./AssignRangeCardBox.vue?vue&type=script&lang=js"

import "./AssignRangeCardBox.vue?vue&type=style&index=0&id=0aa35a2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa35a2a"]])

export default __exports__